export default {
    brand: [{
            brandName: "哈根达斯",
            area: [{
                area: "convenienceStore",
                channel: [{
                        rank: 82.5,
                        person: 597366,
                        channel: ['Lbs', 'building'],
                        reach: [{
                                text: ['65%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 65
                                },
                            }, {
                                text: ['36%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 36
                                },
                            }, {
                                text: ['4.7%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    }, {
                        rank: 88.3,
                        person: 656964,
                        channel: ['Lbs', 'transit'],
                        reach: [{
                                text: ['71%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 71
                                },
                            }, {
                                text: ['41%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 41
                                },
                            }, {
                                text: ['3.7%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 4
                                },
                            }

                        ]
                    }, {
                        rank: 92.1,
                        person: 690228,
                        channel: ['Lbs', 'metro'],
                        reach: [{
                                text: ['75%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 75
                                },
                            }, {
                                text: ['42%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 42
                                },
                            }, {
                                text: ['3.2%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    },

                    {
                        rank: 56.7,
                        person: 422730,
                        channel: ['Lbs', 'building', 'transit'],
                        reach: [{
                                text: ['46%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 46
                                },
                            }, {
                                text: ['31%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 31
                                },
                            }, {
                                text: ['6.9%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 7
                                },
                            }

                        ]
                    }, {
                        rank: 60.4,
                        person: 455994,
                        channel: ['Lbs', 'building', 'metro'],
                        reach: [{
                                text: ['49%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 49
                                },
                            }, {
                                text: ['33%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 33
                                },
                            }, {
                                text: ['6.4%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    }, {
                        rank: 66.3,
                        person: 515592,
                        channel: ['Lbs', 'metro', 'transit'],
                        reach: [{
                                text: ['56%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 56
                                },
                            }, {
                                text: ['38%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 38
                                },
                            }, {
                                text: ['5.4%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    },

                ]
            }, {
                area: "bigStore",
                channel: [{
                        rank: 82.1,
                        person: 597366,
                        channel: ['Lbs', 'building'],
                        reach: [{
                                text: ['65%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 65
                                },
                            }, {
                                text: ['36%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 36
                                },
                            }, {
                                text: ['4.6%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    }, {
                        rank: 88.0,
                        person: 656964,
                        channel: ['Lbs', 'transit'],
                        reach: [{
                                text: ['71%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 71
                                },
                            }, {
                                text: ['41%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 41
                                },
                            }, {
                                text: ['3.7%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 4
                                },
                            }

                        ]
                    }, {
                        rank: 91.8,
                        person: 690228,
                        channel: ['Lbs', 'metro'],
                        reach: [{
                                text: ['75%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 75
                                },
                            }, {
                                text: ['42%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 42
                                },
                            }, {
                                text: ['3.2%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    },

                    {
                        rank: 56.1,
                        person: 422730,
                        channel: ['Lbs', 'building', 'transit'],
                        reach: [{
                                text: ['46%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 46
                                },
                            }, {
                                text: ['31%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 31
                                },
                            }, {
                                text: ['6.8%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 7
                                },
                            }

                        ]
                    }, {
                        rank: 59.9,
                        person: 455994,
                        channel: ['Lbs', 'building', 'metro'],
                        reach: [{
                                text: ['49%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 49
                                },
                            }, {
                                text: ['33%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 33
                                },
                            }, {
                                text: ['6.3%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    }, {
                        rank: 65.8,
                        person: 515592,
                        channel: ['Lbs', 'metro', 'transit'],
                        reach: [{
                                text: ['56%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 56
                                },
                            }, {
                                text: ['38%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 38
                                },
                            }, {
                                text: ['5.4%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    },


                ]
            }, {
                area: "Watsons",
                channel: [{
                        rank: 71.2,
                        person: 597366,
                        channel: ['Lbs', 'building'],
                        reach: [{
                                text: ['65%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 65
                                },
                            }, {
                                text: ['36%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 36
                                },
                            }, {
                                text: ['3.9%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 4
                                },
                            }

                        ]
                    }, {
                        rank: 79.4,
                        person: 656964,
                        channel: ['Lbs', 'transit'],
                        reach: [{
                                text: ['71%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 71
                                },
                            }, {
                                text: ['41%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 41
                                },
                            }, {
                                text: ['3.0%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    }, {
                        rank: 84.4,
                        person: 690228,
                        channel: ['Lbs', 'metro'],
                        reach: [{
                                text: ['75%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 75
                                },
                            }, {
                                text: ['42%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 42
                                },
                            }, {
                                text: ['2.6%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    },

                    {
                        rank: 40.0,
                        person: 422730,
                        channel: ['Lbs', 'building', 'transit'],
                        reach: [{
                                text: ['46%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 46
                                },
                            }, {
                                text: ['31%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 31
                                },
                            }, {
                                text: ['5.7%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    }, {
                        rank: 45.0,
                        person: 455994,
                        channel: ['Lbs', 'building', 'metro'],
                        reach: [{
                                text: ['49%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 49
                                },
                            }, {
                                text: ['33%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 33
                                },
                            }, {
                                text: ['5.3%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    }, {
                        rank: 53.2,
                        person: 515592,
                        channel: ['Lbs', 'metro', 'transit'],
                        reach: [{
                                text: ['56%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 56
                                },
                            }, {
                                text: ['38%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 38
                                },
                            }, {
                                text: ['4.5%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    },

                ]
            }]
        }, {
            brandName: "资生堂",
            area: [{
                area: "convenienceStore",
                channel: [{
                        rank: 86.7,
                        person: 620789,
                        channel: ['Lbs', 'building'],
                        reach: [{
                                text: ['67%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 67
                                },
                            }, {
                                text: ['37%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 37
                                },
                            }, {
                                text: ['4.5%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    }, {
                        rank: 92.9,
                        person: 691268,
                        channel: ['Lbs', 'transit'],
                        reach: [{
                                text: ['75%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 75
                                },
                            }, {
                                text: ['42%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 42
                                },
                            }, {
                                text: ['3.4%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    }, {
                        rank: 93.9,
                        person: 709632,
                        channel: ['Lbs', 'metro'],
                        reach: [{
                                text: ['77%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 77
                                },
                            }, {
                                text: ['43%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 43
                                },
                            }, {
                                text: ['3.0%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    },

                    {
                        rank: 71.3,
                        person: 480457,
                        channel: ['Lbs', 'building', 'transit'],
                        reach: [{
                                text: ['52%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 52
                                },
                            }, {
                                text: ['33%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 33
                                },
                            }, {
                                text: ['6.4%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    }, {
                        rank: 72.3,
                        person: 498821,
                        channel: ['Lbs', 'building', 'metro'],
                        reach: [{
                                text: ['54%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 54
                                },
                            }, {
                                text: ['34%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 34
                                },
                            }, {
                                text: ['6.0%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    }, {
                        rank: 77.5,
                        person: 569300,
                        channel: ['Lbs', 'metro', 'transit'],
                        reach: [{
                                text: ['62%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 62
                                },
                            }, {
                                text: ['39%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 39
                                },
                            }, {
                                text: ['4.9%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    },


                ]
            }, {
                area: "bigStore",
                channel: [{
                        rank: 79.3,
                        person: 620789,
                        channel: ['Lbs', 'building'],
                        reach: [{
                                text: ['67%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 67
                                },
                            }, {
                                text: ['37%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 37
                                },
                            }, {
                                text: ['3.9%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 4
                                },
                            }

                        ]
                    }, {
                        rank: 86.6,
                        person: 691268,
                        channel: ['Lbs', 'transit'],
                        reach: [{
                                text: ['75%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 75
                                },
                            }, {
                                text: ['42%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 42
                                },
                            }, {
                                text: ['3.0%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    }, {
                        rank: 88.2,
                        person: 709632,
                        channel: ['Lbs', 'metro'],
                        reach: [{
                                text: ['77%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 77
                                },
                            }, {
                                text: ['43%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 43
                                },
                            }, {
                                text: ['2.7%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    },

                    {
                        rank: 59.5,
                        person: 480457,
                        channel: ['Lbs', 'building', 'transit'],
                        reach: [{
                                text: ['52%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 52
                                },
                            }, {
                                text: ['33%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 33
                                },
                            }, {
                                text: ['5.6%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    }, {
                        rank: 61.1,
                        person: 498821,
                        channel: ['Lbs', 'building', 'metro'],
                        reach: [{
                                text: ['54%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 54
                                },
                            }, {
                                text: ['34%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 34
                                },
                            }, {
                                text: ['5.3%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    }, {
                        rank: 68.4,
                        person: 569300,
                        channel: ['Lbs', 'metro', 'transit'],
                        reach: [{
                                text: ['62%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 62
                                },
                            }, {
                                text: ['39%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 39
                                },
                            }, {
                                text: ['4.3%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 4
                                },
                            }

                        ]
                    },


                ]
            }, {
                area: "Watsons",
                channel: [{
                        rank: 78.9,
                        person: 620789,
                        channel: ['Lbs', 'building'],
                        reach: [{
                                text: ['67%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 67
                                },
                            }, {
                                text: ['37%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 37
                                },
                            }, {
                                text: ['3.9%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 4
                                },
                            }

                        ]
                    }, {
                        rank: 86.3,
                        person: 691268,
                        channel: ['Lbs', 'transit'],
                        reach: [{
                                text: ['75%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 75
                                },
                            }, {
                                text: ['42%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 42
                                },
                            }, {
                                text: ['2.9%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    }, {
                        rank: 88.0,
                        person: 709632,
                        channel: ['Lbs', 'metro'],
                        reach: [{
                                text: ['77%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 77
                                },
                            }, {
                                text: ['43%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 43
                                },
                            }, {
                                text: ['2.7%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    },

                    {
                        rank: 59.0,
                        person: 480457,
                        channel: ['Lbs', 'building', 'transit'],
                        reach: [{
                                text: ['52%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 52
                                },
                            }, {
                                text: ['33%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 33
                                },
                            }, {
                                text: ['5.5%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    }, {
                        rank: 60.6,
                        person: 498821,
                        channel: ['Lbs', 'building', 'metro'],
                        reach: [{
                                text: ['54%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 54
                                },
                            }, {
                                text: ['34%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 34
                                },
                            }, {
                                text: ['5.3%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    }, {
                        rank: 68.0,
                        person: 569300,
                        channel: ['Lbs', 'metro', 'transit'],
                        reach: [{
                                text: ['62%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 62
                                },
                            }, {
                                text: ['39%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 39
                                },
                            }, {
                                text: ['4.3%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 4
                                },
                            }

                        ]
                    },


                ]
            }]
        }, {
            brandName: "花王",
            area: [{
                area: "convenienceStore",
                channel: [{
                        rank: 71.9,
                        person: 586856,
                        channel: ['Lbs', 'building'],
                        reach: [{
                                text: ['64%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 64
                                },
                            }, {
                                text: ['35%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 35
                                },
                            }, {
                                text: ['4.4%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 4
                                },
                            }

                        ]
                    }, {
                        rank: 86.0,
                        person: 674428,
                        channel: ['Lbs', 'transit'],
                        reach: [{
                                text: ['73%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 73
                                },
                            }, {
                                text: ['41%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 41
                                },
                            }, {
                                text: ['3.2%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    }, {
                        rank: 85.3,
                        person: 676368,
                        channel: ['Lbs', 'metro'],
                        reach: [{
                                text: ['73%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 73
                                },
                            }, {
                                text: ['42%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 42
                                },
                            }, {
                                text: ['3.1%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    },

                    {
                        rank: 42.1,
                        person: 429683,
                        channel: ['Lbs', 'building', 'transit'],
                        reach: [{
                                text: ['47%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 47
                                },
                            }, {
                                text: ['31%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 31
                                },
                            }, {
                                text: ['6.3%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    }, {
                        rank: 41.4,
                        person: 431624,
                        channel: ['Lbs', 'building', 'metro'],
                        reach: [{
                                text: ['47%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 47
                                },
                            }, {
                                text: ['32%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 32
                                },
                            }, {
                                text: ['6.2%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    }, {
                        rank: 55.5,
                        person: 519196,
                        channel: ['Lbs', 'metro', 'transit'],
                        reach: [{
                                text: ['56%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 56
                                },
                            }, {
                                text: ['38%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 38
                                },
                            }, {
                                text: ['4.9%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    },


                ]
            }, {
                area: "bigStore",
                channel: [{
                        rank: 85.8,
                        person: 586856,
                        channel: ['Lbs', 'building'],
                        reach: [{
                                text: ['64%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 64
                                },
                            }, {
                                text: ['35%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 35
                                },
                            }, {
                                text: ['5.6%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    }, {
                        rank: 96.0,
                        person: 674428,
                        channel: ['Lbs', 'transit'],
                        reach: [{
                                text: ['73%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 73
                                },
                            }, {
                                text: ['41%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 41
                                },
                            }, {
                                text: ['4.0%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 4
                                },
                            }

                        ]
                    }, {
                        rank: 95.0,
                        person: 676368,
                        channel: ['Lbs', 'metro'],
                        reach: [{
                                text: ['73%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 73
                                },
                            }, {
                                text: ['42%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 42
                                },
                            }, {
                                text: ['3.9%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 4
                                },
                            }

                        ]
                    },

                    {
                        rank: 61.8,
                        person: 429683,
                        channel: ['Lbs', 'building', 'transit'],
                        reach: [{
                                text: ['47%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 47
                                },
                            }, {
                                text: ['31%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 31
                                },
                            }, {
                                text: ['7.9%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 8
                                },
                            }

                        ]
                    }, {
                        rank: 60.8,
                        person: 431624,
                        channel: ['Lbs', 'building', 'metro'],
                        reach: [{
                                text: ['47%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 47
                                },
                            }, {
                                text: ['32%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 32
                                },
                            }, {
                                text: ['7.8%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 8
                                },
                            }

                        ]
                    }, {
                        rank: 71.1,
                        person: 519196,
                        channel: ['Lbs', 'metro', 'transit'],
                        reach: [{
                                text: ['56%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 56
                                },
                            }, {
                                text: ['38%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 38
                                },
                            }, {
                                text: ['6.2%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 6
                                },
                            }

                        ]
                    },


                ]
            }, {
                area: "Watsons",
                channel: [{
                        rank: 75.4,
                        person: 586856,
                        channel: ['Lbs', 'building'],
                        reach: [{
                                text: ['64%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 64
                                },
                            }, {
                                text: ['35%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 35
                                },
                            }, {
                                text: ['4.7%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    }, {
                        rank: 88.5,
                        person: 674428,
                        channel: ['Lbs', 'transit'],
                        reach: [{
                                text: ['73%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 73
                                },
                            }, {
                                text: ['41%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 41
                                },
                            }, {
                                text: ['3.4%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    }, {
                        rank: 87.8,
                        person: 676368,
                        channel: ['Lbs', 'metro'],
                        reach: [{
                                text: ['73%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 73
                                },
                            }, {
                                text: ['42%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 42
                                },
                            }, {
                                text: ['3.3%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 3
                                },
                            }

                        ]
                    },

                    {
                        rank: 47.1,
                        person: 429683,
                        channel: ['Lbs', 'building', 'transit'],
                        reach: [{
                                text: ['47%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 47
                                },
                            }, {
                                text: ['31%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 31
                                },
                            }, {
                                text: ['6.7%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 7
                                },
                            }

                        ]
                    }, {
                        rank: 46.4,
                        person: 431624,
                        channel: ['Lbs', 'building', 'metro'],
                        reach: [{
                                text: ['47%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 47
                                },
                            }, {
                                text: ['32%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 32
                                },
                            }, {
                                text: ['6.6%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 7
                                },
                            }

                        ]
                    }, {
                        rank: 59.5,
                        person: 519196,
                        channel: ['Lbs', 'metro', 'transit'],
                        reach: [{
                                text: ['56%', 'Reach 1+', ''],
                                circle: {
                                    color: "#7b4bff",
                                    num: 56
                                },
                            }, {
                                text: ['38%', 'Reach 3+', ],
                                circle: {
                                    color: "#0575e6",
                                    num: 38
                                },
                            }, {
                                text: ['5.3%', '到店率', 'Store arrival'],
                                circle: {
                                    color: "#9ad5ff",
                                    num: 5
                                },
                            }

                        ]
                    },


                ]
            }]
        },

    ]
}


// WEBPACK FOOTER //
// ./src/assets/data.js